/*
 * Registers the Notifications page. Same shape as Connect, Live and the Agents page:
 * `PageBlueprint`, `pluginId: 'app'`, `oss_apps/backstage` untouched.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const NOTIFICATIONS_PATH = '/notifications';

const notificationsPage = PageBlueprint.make({
  name: 'stackschematic-notifications',
  params: {
    path: NOTIFICATIONS_PATH,
    loader: async () => {
      const { NotificationsPage } = await import('./NotificationsPage');
      return <NotificationsPage />;
    },
  },
});

export const stackSchematicNotificationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [notificationsPage],
});
